export const musicList2 = [
  {
    title: "밤에 듣기 좋은 믹스",
    id: "mix1",
    photo: "https://dongsooo.github.io/imgs/img/02_mix-01.jpg",
    musicTitle: "Relaxing Mix",
  },
  {
    id: "mix2",
    photo: "https://dongsooo.github.io/imgs/img/02_mix-02.jpg",
    musicTitle: "80's City Pop Mix",
  },
  {
    id: "mix3",
    photo: "https://dongsooo.github.io/imgs/img/02_mix-03.jpg",
    musicTitle: "Inspirational Motivational Musics",
  },
  {
    id: "mix4",
    photo: "https://dongsooo.github.io/imgs/img/02_mix-04.jpg",
    musicTitle: "relaxing lofi radio",
  },
  {
    id: "mix5",
    photo: "https://dongsooo.github.io/imgs/img/02_mix-05.jpg",
    musicTitle: "lofi radio",
  },
];
